import { render, staticRenderFns } from "./VLoaderModal.vue?vue&type=template&id=53a9d757&"
import script from "./VLoaderModal.vue?vue&type=script&lang=js&"
export * from "./VLoaderModal.vue?vue&type=script&lang=js&"
import style0 from "./VLoaderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports